import { Example } from "../models/ExampleModel";
import { ExplanationModel } from "../models/ExplanationModel";
import { TableModel } from "../models/table-models/TableModel";

export const possessivePronounsExplanation: ExplanationModel = {
    title: "📖 What are Pronombres Posesivos?",
    description: "Possessive pronouns indicate ownership and replace a noun already mentioned. Unlike possessive adjectives, they stand alone and must agree in gender and number with the noun they refer to.",
    bulletPoints: [
        "Possessive pronouns replace a noun instead of describing it.",
        "They must match the noun in gender and number.",
        "Often used with the verb 'ser' (to be) or at the end of a sentence.",
        "Different from possessive adjectives, which accompany a noun."
    ],
    examples: [
        "This book is mine. → Este libro es mío.",
        "The car is yours. → El coche es tuyo.",
        "That house is theirs. → Esa casa es suya."
    ]
};

export const pronombresPosesivosTable: TableModel = {
    title: "Pronombres Posesivos",
    headers: ["Singular", "Plural"],
    rows: [
        ["Mío / Mía", "Míos / Mías"],
        ["Tuyo / Tuya", "Tuyos / Tuyas"],
        ["Suyo / Suya", "Suyos / Suyas"],
        ["Nuestro / Nuestra", "Nuestros / Nuestras"],
        ["Vuestro / Vuestra", "Vuestros / Vuestras"],
        ["Suyo / Suya", "Suyos / Suyas"]
    ]
};

export const possessiveAdjectivesTable: TableModel = {
    title: "Possessive Adjectives in Spanish",
    headers: ["Owner", "Singular Masculine", "Singular Feminine", "Plural Masculine", "Plural Feminine"],
    rows: [
        ["yo", "mi libro", "mi casa", "mis libros", "mis casas"],
        ["tú", "tu coche", "tu silla", "tus coches", "tus sillas"],
        ["él/ella/usted", "su perro", "su amiga", "sus perros", "sus amigas"],
        ["nosotros/as", "nuestro amigo", "nuestra casa", "nuestros amigos", "nuestras casas"],
        ["vosotros/as", "vuestro hermano", "vuestra madre", "vuestros hermanos", "vuestras madres"],
        ["ellos/ellas/ustedes", "su país", "su escuela", "sus países", "sus escuelas"]
    ]
};

export const possessiveAdjectivesExplanation: ExplanationModel = {
    title: "📖 What are Adjetivos Posesivos?",
    description: "Possessive adjectives indicate ownership but always accompany a noun. Unlike possessive pronouns, they cannot stand alone.",
    bulletPoints: [
        "Possessive adjectives describe a noun instead of replacing it.",
        "They must match the noun in gender and number.",
        "They come before the noun they describe.",
        "Common examples include: mi, tu, su, nuestro, vuestro, su."
    ],
    examples: [
        "This is my book. → Este es mi libro.",
        "Your car is red. → Tu coche es rojo.",
        "Their house is big. → Su casa es grande."
    ]
};

export const posesivoExamples: Example[] = [
    {
        sentence: "Este coche es mío.",
        explanation: "'This car is mine.' The possessive pronoun 'mío' indicates ownership of the car."
    },
    {
        sentence: "La casa grande es tuya.",
        explanation: "'The big house is yours.' The possessive pronoun 'tuya' shows ownership of the house."
    },
    {
        sentence: "El libro azul es suyo.",
        explanation: "'The blue book is his/hers/theirs.' The pronoun 'suyo' shows possession of the book."
    },
    {
        sentence: "Esos zapatos son nuestros.",
        explanation: "'Those shoes are ours.' The pronoun 'nuestros' indicates that the shoes belong to the speakers."
    },
    {
        sentence: "Las llaves son vuestras.",
        explanation: "'The keys are yours.' The possessive 'vuestras' is used for plural 'you' (vosotros)."
    },
    {
        sentence: "El problema no es suyo.",
        explanation: "'The problem is not theirs.' The pronoun 'suyo' is used to indicate that the problem is not possessed by them."
    }
];
